var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrincess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.847 64.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Princess") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.345 15.852 18.701 15.532 31.183 12.56 6.684 6.434 12.901 31.306 18.345 15.852"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.497 9.81 6.497 56.275 12.303 33.043 6.497 9.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.292 12.056 56.528 6.248 10.06 6.248 33.292 12.056"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.234 33.043 47.385 16.442 33.292 13.086 19.198 16.442 13.349 33.043 19.198 49.644 33.292 53 47.385 49.644 53.234 33.043"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.701 50.554 18.345 50.234 12.901 34.779 6.684 59.652 31.183 53.526 18.701 50.554"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.292 54.03 10.059 59.838 56.529 59.838 33.292 54.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.883 15.532 48.238 15.852 53.683 31.307 59.901 6.435 35.4 12.56 47.883 15.532"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.238 50.234 47.883 50.554 35.4 53.526 59.901 59.651 53.683 34.779 48.238 50.234"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.089 56.277 60.089 9.809 54.28 33.043 60.089 56.277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.014,4.826V61.243H61.431V4.826ZM33.292,53,19.2,49.644l-5.849-16.6,5.849-16.6,14.094-3.356,14.093,3.356,5.849,16.6-5.849,16.6Zm0-40.944L10.06,6.248H56.528Zm-2.109.5L18.7,15.532l-.356.32L12.9,31.306,6.684,6.434ZM6.5,9.81,12.3,33.043,6.5,56.275Zm6.4,24.969,5.444,15.455.356.32,12.482,2.972-24.5,6.126ZM33.292,54.03l23.237,5.808H10.059Zm2.108-.5,12.483-2.972.355-.32,5.445-15.455L59.9,59.651Zm24.689,2.751L54.28,33.043,60.089,9.809Zm-6.406-24.97L48.238,15.852l-.355-.32L35.4,12.56,59.9,6.435Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincess);
export default __webpack_public_path__ + "static/media/princess.5786a034ca7001fe7cf97458a321071f.svg";
export { ForwardRef as ReactComponent };